import { Component, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SparepartsService } from '../../service/spareparts.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TakeSpareDetailComponent } from './take-spare-detail/take-spare-detail.component';
import { OutDetailComponent } from '../out-spare/out-detail/out-detail.component';
import endOfMonth from 'date-fns/endOfMonth';
import startOfMonth from 'date-fns/startOfMonth';

@Component({
  selector: 'app-take-spare',
  templateUrl: './take-spare.component.html',
  styleUrls: ['./take-spare.component.less']
})
export class TakeSpareComponent implements OnInit {

  validateForm: FormGroup;
  listOfData = [];
  startRow: number;
  // 分页查询条件
  pageIndex: number;
  pageSize: number;
  total = 0;
  loading = true;
  ranges = { 今天: [new Date(), new Date()], 本月: [startOfMonth(new Date()), endOfMonth(new Date())] };
  private datePipe: DatePipe = new DatePipe('zh-cn');
  constructor(
    private fb: FormBuilder,
    private modal: NzModalService,
    public message: NzMessageService,
    private router: Router,
    private dataService: SparepartsService
  ) {
    this.startRow = 1;
    this.pageIndex = 1;
    this.pageSize = 10;
  }


  ngOnInit(): void {
    this.validateForm = this.fb.group({ typeId: null, takeSpareNo: null, date: null });
    this.queryStockData(1);
  }



  /**
   * 查询领料单记录数据
   *  @param flag 1表示点击搜索按钮，2表示翻页
   */
  async queryStockData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    const result = await this.dataService.queryTakeSparesData(this.validateForm.value, this.pageIndex, this.pageSize);
    this.loading = false;
    if (result === null) {
      this.message.create('error', '领料单记录查询失败!');
      return;
    } else {
      this.listOfData = result.list;
      this.listOfData.forEach(element => {
        element.createTime = this.formatDate(element.createTime);
        element.updateTime = this.formatDate(element.updateTime);
        if (element.status === '0') {
          element.stat = '未出库';
        } else {
          element.stat = '已出库';
        }
      });
      this.total = result.total;
      this.startRow = result.startRow;
    }
  }
  /**
   * 格式化Date
   * @param date 日期
   */
  public formatDate(date: any): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
  }
  submitForm() {
    this.queryStockData(1);
  }

  resetForm() {
    this.validateForm.setValue({ typeId: null, takeSpareNo: null, date: null });
    this.queryStockData(1);
  }
  /**
   * 删除领料单记录
   */
  async deleteData(stNo: string) {
    this.modal.confirm({
      nzTitle: '<i>确认要删除该领料单记录信息?</i>',
      nzOnOk: async () => {
        const result = await this.dataService.deleteTakeSparesData(stNo);
        if (result === 0) {
          this.message.create('error', '领料单记录删除失败!');
        } else {
          this.message.create('success', '领料单记录删除成功!');
          this.queryStockData(2);
        }
      }
    });
  }
  /**
   * 查询领料单详情
   * @param woNo 领料单编号
   */
  async DetailData(spareNo: string, permissionNo: string, desc: string, tflag: number) {
    const modals = this.modal.create({
      nzTitle: '领料单[' + spareNo + ']详情',
      nzContent: TakeSpareDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 1000,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        takeSpareNo: spareNo,
        missionNo: permissionNo,
        description: desc,
        flag: tflag
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.resetForm();
            this.queryStockData(2);
          }
        }
      }
    );
  }

  onPageIndexChange(pageIndex): void {
    this.pageIndex = pageIndex;
    this.queryStockData(2);
  }


  /**
   * 创建入库单
   */
  createTakeSpares() {
    const modals = this.modal.create({
      nzTitle: '创建-领料单',
      nzContent: TakeSpareDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 1000,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        takeSpareNo: null,
        missionNo: null,
        description: null,
        flag: 1
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.resetForm();
            this.queryStockData(1);
          }
        }
      }
    );
  }

  /**
   * 创建出库单
   */
  createOutSpare(currentRlNo: string) {
    const modals = this.modal.create({
      nzTitle: '创建-出库单',
      nzContent: OutDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 1000,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        outTypes: [{
          title: '领用出库',
          value: '0',
          key: '0'
        }],
        no: null,
        typeId: 0,
        receiver: null,
        rlNo: currentRlNo
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.resetForm();
            this.queryStockData(1);
          }
        }
      }
    );
  }
  /**
   * 库存数据
   */
  stockData() {
    this.router.navigate(['/web/facility/SparePartsManagement']);
  }
  /**
   * 领料单管理
   */
  outSparParts() {
    this.router.navigate(['/web/facility/OutSpareParts']);
  }
  /**
   * 入库单管理
   */
  entrySpareParts() {
    this.router.navigate(['/web/facility/EntrySpareParts']);
  }
  onChange(result: Date[]): void {
    // console.log('From: ', result[0], ', to: ', result[1]);
    // console.log('date:' + this.validateForm.value.date[0]);
  }

}
